import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiRepository,
  Result,
} from '@softline/core';
import { SOFTLINE_API_LIEFERANTENSTAMM_FIBU } from '../lieferantenstamm.api';
import { LieferantenQuery } from '../types/lieferanten-query';
import { SupplierFibu } from '../types/supplier-fibu';

@Injectable()
export class LieferantenFibuRepository extends ReadonlyHttpApiRepository<
  Result<SupplierFibu>,
  LieferantenQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_LIEFERANTENSTAMM_FIBU);
  }

  override getLoadPathParams(params: LieferantenQuery): Dictionary<unknown> {
    return { id: params.id };
  }
}
